module.exports = __webpack_public_path__ + "img/gmtcsz.08259ab2.jpg";